export class OrderShippingTrackingPackageDetail {
    id: number;
    trackingNumbers: string;
}
